import { EmployeeOrder } from '../types/employee.types'

export default function getPriorityWithinSubCategory(subCategory: string, employeeOrder?: EmployeeOrder[]): number {
  let priorityWithinSubCategory = Infinity

  if (!employeeOrder) {
    return priorityWithinSubCategory
  }
  // eslint-disable-next-line no-restricted-syntax, fp/no-loops
  for (const order of employeeOrder) {
    if (order.subCategory === subCategory) {
      priorityWithinSubCategory = Math.min(
        priorityWithinSubCategory,
        Number(order.employeeOrderInSubCategory) || Infinity,
      )
    }
  }
  return priorityWithinSubCategory
}
